"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = require("@angular/forms");
var lang_1 = require("../util/lang");
exports.lte = function (lte) {
    return function (control) {
        if (!lang_1.isPresent(lte))
            return null;
        if (lang_1.isPresent(forms_1.Validators.required(control)))
            return null;
        var v = +control.value;
        return v <= +lte ? null : { lte: true };
    };
};
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/ng2-validation/dist/less-than-equal/validator.js
// module id = ../../../../ng2-validation/dist/less-than-equal/validator.js
// module chunks = 3